import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { IntroComponent } from './intro/intro.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ContactCheckComponent } from './contact-check/contact-check.component';
import { SustainabilityAchievedComponent } from './sustainability-achieved/sustainability-achieved.component';
import { SustainabilityFutureComponent } from './sustainability-future/sustainability-future.component';

@NgModule({
  declarations: [
    AppComponent,
    IntroComponent,
    FooterComponent,
    HomeComponent,
    ErrorPageComponent,
    DashboardComponent,
    ContactCheckComponent,
    SustainabilityAchievedComponent,
    SustainabilityFutureComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCqImpLxOc_wYKVSzzhkdDeXo8xIKO9zlQ'
    })
  ],
  providers: [
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
